import { BackendReport, Report, ReportRun, BackendReportRun, BackendShopassReport, ShopassReport } from './types'

export const normalizeReports = (reports: BackendReport[]): Report[] => {
  const test = reports.reduce((acc, report) => {
    const runs = report.runs.map(run => ({
      runId: run.uid,
      status: run.status,
      createdAt: run.created_at,
      updatedAt: run.updated_at,
      fileKey: run.file_key,
      fileSize: run.file_size,
      startDate: run.start_date,
      endDate: run.end_date
    }))

    return [
      ...acc,
      {
        reportId: report.report_id,
        name: report.name,
        frequencyType: report.frequencyType,
        frequency: report.frequency,
        status: report.status,
        type: report.type,
        runStartAt: report.runStartAt,
        startDate: report.startDate,
        endDate: report.endDate,
        columns: report.columns ?? [],
        emails: report.emails ?? [],
        runs
      }
    ]
  }, [] as Report[])

  return test
}

export const normalizeReportRuns = (reportRuns: BackendReportRun[]): ReportRun[] => {
  return reportRuns.map(run => ({
    runId: run.uid,
    status: run.status,
    createdAt: run.created_at,
    updatedAt: run.updated_at,
    fileKey: run.file_key,
    fileSize: run.file_size,
    startDate: run.start_date,
    endDate: run.end_date
  }))
}

export const normalizeShopassReports = (reports: BackendShopassReport[]): ShopassReport[] => {
  return reports.map(report => {
    return {
      runId: report.uid,
      status: report.status,
      createdAt: report.created_at,
      startDate: report.start_date,
      endDate: report.end_date
    }
  })
}
